import { defineStore } from 'pinia'

import type { AnalyticsState } from '~/store/analytics/analytics.types'

import { StoreId } from '~/store'
import { Success } from '@/types/api/results'

export const useAnalyticsStore = defineStore(StoreId.ANALYTICS, {
  state: (): AnalyticsState => {
    return {
      analytics: {
        google: {
          city_id: '',
          prefix: '',
          verification: '',
          main_id: '',
        },
        yandex: {
          city_id: '',
          verification: '',
          main_id: '',
        },
        carrotquest_id: '',
        facebook_id: '',
        tiktok_id: '',
        vk_pixel_id: '',
      },
    }
  },
  actions: {
    async getAnalyticsCityForCommonPage() {
      const { $apiService } = useNuxtApp()
      const result = await $apiService.cities.fetchAnalyticsForCommonPage()

      if (result instanceof Success) {
        this.analytics = result.data
      }
    },
  },
  getters: {
    yandexAnalyticsProps: ({ analytics }) => analytics?.yandex, // Яндекс Метрика
    googleAnalyticsProps: ({ analytics }) => analytics?.google, // Google Analytics
  },
})
